module.exports = __webpack_public_path__ + "static/media/logo_white.a2d881a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white.svg
// module id = 156
// module chunks = 0